<!-- 面试题库详情页面 -->
<template>
  <div>
    <span id="spanData">
      <el-card class="box-card">
        <!-- 使用table标签布局 -->
        <table>
          <!-- 设置标题 -->
          <tr>
            <th colspan="2">
              <h1 id="h1Title">{{ respContentData.title }}</h1>
            </th>
          </tr>
          <!-- 设置标题信息 -->
          <tr>
            <th colspan="2">
              <el-tag id="tag1" type="info">
                <!-- 用户名 -->
                <span style="color: black; font-size: small">
                    {{ respContentData.nickName!=null ? respContentData.nickName : respContentData.userName}}
                </span>
                <!-- 创建时间 -->
                <span style="margin-left: 20px">
                  <i class="el-icon-time"></i>
                  于&nbsp;&nbsp;{{ respContentData.createtime }}&nbsp;&nbsp;创建 </span
                ><br />
                <!-- 文章标签 -->
                <span>
                  文章标签:
                  <el-tag size="mini" style="margin-left: 10px" 
                  v-for="(item,index) in respContentData.dynamicTagList" :key="index">
                  {{ item }}
                </el-tag>

                </span>
              </el-tag>
            </th>
          </tr>
          <!-- 设置内容 -->
          <tr>
            <td colspan="2">
              <el-card shadow="always">
                <div v-html="respContentData.content"></div>
              </el-card>
            </td>
          </tr>
        </table>
      </el-card>
    </span>
  </div>
</template>
   
  
  <script>
  import {findBankContent} from '@/api/questionBank/questionBankDetails.js'
export default {
  data() {
    return {
      userName: "万叶",
      createTime: "2014-01-02 12:16:02",
      content:'<p>我是内容<p>',
      respContentData:{} //响应回来的内容数据
    };
  },

//   一进入页面执行
  created() {
    
    // 获取内容信息
    this.gainDetails();
  },
  computed:{
    // 获取传递过来的bankId
    gainBankId(){
        return this.$route.params.bankId;
    }
  },

  methods: {
    // 获取内容信息
    async gainDetails(){
        // 获取传递过来的值
        console.log('获取传递过来的值：'+this.gainBankId)
        // 调用查询接口获取内容数据
        const contentData= await findBankContent(this.gainBankId);
        this.respContentData=contentData.data;
    }
  },
};
</script>

  <style scoped>
/* 设置标题内容样式 */
#tag1 {
  width: 100%;
  height: auto;
}

/* 标题样式 */
#h1Title {
  text-align: center;
}

/* 布局table样式 */
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  /* border: 1px solid #000; */
  padding: 8px;
  text-align: left;
}

/* 外围span标签样式 */
#spanData {
  display: flex;
  justify-content: center;
}
/* 外围card样式 */
.box-card {
  width: 70%;
}
</style>